import { Environments } from './environment-names';
import { adfProductSettings } from 'product-settings/product-settings.adf';

export const environment = Environments.production;
export const isProd = true;
export const buildVersion = '1.0.100926.3';
export const sourceBranch = 'regular-deployment-10-09-2026';

export const localReleaseNotesURL = 'assets/external/release-notes/release-notes.json';

export const productSettings = {
    value: adfProductSettings
};
